(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bds-presale-announcement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach((timer) => {
    const target = new Date(timer.dataset.countdown).getTime();
    if (!Number.isFinite(target)) return;
    const tick = () => {
      const remaining = Math.max(0, target - Date.now());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      timer.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      timer.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    };
    tick();
    window.setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bds-presale-reviews"] && !Shopify.designMode) return;
  try {
    
  const marqueeStates = new WeakMap();

  function setupReviewMarquee(section) {
    if (!section || marqueeStates.has(section)) return;
    const track = section.querySelector('.bds-presale-reviews__track');
    const firstGroup = section.querySelector('.bds-presale-reviews__group');
    if (!track || !firstGroup || firstGroup.children.length === 0) return;

    const speed = Number(section.dataset.marqueeSpeed) || 48;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame;
    let lastTime = performance.now();
    let paused = false;
    let resumeAt = 0;
    let position = track.scrollLeft;

    const pauseForInteraction = () => { position = track.scrollLeft; resumeAt = performance.now() + 1600; };
    const pause = () => { position = track.scrollLeft; paused = true; };
    const resume = () => { position = track.scrollLeft; paused = false; lastTime = performance.now(); };

    const animate = (time) => {
      const elapsed = Math.min(time - lastTime, 64);
      if (!paused && time >= resumeAt && !document.hidden && !reducedMotion.matches) {
        position += speed * elapsed / 1000;
        const loopWidth = firstGroup.getBoundingClientRect().width;
        if (loopWidth && position >= loopWidth) position -= loopWidth;
        track.scrollLeft = position;
      }
      lastTime = time;
      frame = requestAnimationFrame(animate);
    };

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('pointerdown', pause);
    track.addEventListener('pointerup', () => { paused = false; pauseForInteraction(); });
    track.addEventListener('pointercancel', resume);
    track.addEventListener('wheel', pauseForInteraction, { passive: true });
    track.addEventListener('touchmove', pauseForInteraction, { passive: true });
    frame = requestAnimationFrame(animate);

    marqueeStates.set(section, () => cancelAnimationFrame(frame));
  }

  document.querySelectorAll('[data-bds-presale-review-marquee]').forEach(setupReviewMarquee);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-bds-presale-review-marquee]');
    if (section) setupReviewMarquee(section);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-bds-presale-review-marquee]');
    const cleanup = section && marqueeStates.get(section);
    if (cleanup) cleanup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bds-presale-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-bds-presale-sticky-cart]');
    const hero = document.querySelector('.bds-presale-hero');
    const offer = document.querySelector('.bds-presale-offer');
    if (!bar || !hero || !bar.querySelector('a.bds-presale-sticky-cart__button')) return;
    const update = () => {
      const afterHero = window.scrollY > hero.offsetTop + hero.offsetHeight - 140;
      const atOffer = offer && offer.getBoundingClientRect().top < window.innerHeight * .82;
      bar.classList.toggle('is-active', window.innerWidth <= 991 && afterHero && !atOffer);
    };

    const trackPresellCta = (event) => {
      const link = event.target.closest('a.bds-presale-sticky-cart__button, a.bds-presale-offer__button');
      if (!link) return;

      const ctaLocation = link.classList.contains('bds-presale-sticky-cart__button') ? 'sticky' : 'offer';
      const eventData = {
        cta_location: ctaLocation,
        cta_text: link.textContent.trim().replace(/\s+/g, ' '),
        source_page: window.location.pathname,
        destination: link.pathname
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'presell_cta_click', ...eventData });

      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'PresellCTA', eventData);
      }

      const isPlainPrimaryClick = event.button === 0
        && !event.metaKey
        && !event.ctrlKey
        && !event.shiftKey
        && !event.altKey
        && link.target !== '_blank';

      if (isPlainPrimaryClick) {
        event.preventDefault();
        window.setTimeout(() => window.location.assign(link.href), 150);
      }
    };

    update();
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    document.addEventListener('click', trackPresellCta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
